// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__21c9f","primary":"Toast_primary__1BN2F","secondary":"Toast_secondary__3IuJC","main":"Toast_main__1ylCB","info":"Toast_info__3bEZF"};